import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { route_with_params, useQueryParams } from 'helpers';
import get from 'lodash/get';
import { URLS } from 'config';
import { PATHS } from 'config';

export default withRouter(
    ({ from, history, to, withParams = {}, location }) => {
        let loc = { ...location };
        let params = { ...withParams };

        if (from === '/account/profile' && get(location.hash, 'length')) {
            to = location.hash.replace('#', '');
            delete loc.hash;
        }

        /* Temporary solution to https://yousician.atlassian.net/browse/YS-16943 */
        const searchParams = useQueryParams();
        if (
            from === '/account/profile' &&
            searchParams.return_to &&
            searchParams.return_to === URLS.support
        ) {
            to = PATHS.login;
            params = { ...params, ...searchParams, zendeskRedirect: true };
        }

        if (to.indexOf('http') === 0) {
            window.location.href = route_with_params(to, params);
            return null;
        }

        useEffect(() => {
            history.push(route_with_params(to, params));
        });

        return null;
    },
);
